import { useState } from 'react'
import styled from 'styled-components'

const MainComponent = (props: MicroFrontendProps) => {
  const [count, setCount] = useState(0)
  function handleClick() {
    setCount(count + 1)
  }
  return (
    <AppContainer>
      <button onClick={handleClick}>You pressed me {count} times</button>
    </AppContainer>
  )
}
const AppContainer = styled.div`
  font-size: 1.8rem;
  color: currentColor;
  font-family: var(--font-noto);
  text-align: center;
`
export default MainComponent
